import classNames from 'classnames';
import {
    Button,
    ButtonProps,
    ButtonRequiredProps,
    ControlProps
} from 'lego-on-react';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';

import './ButtonDecorator.css';

export interface ButtonDecoratorProps {
    valid?: boolean;
}

export class ButtonDecorator extends React.PureComponent<
    ButtonProps & ButtonRequiredProps & ControlProps & ButtonDecoratorProps
> {
    render() {
        const { cls, valid = true, ...passThroughProps } = this.props;

        return (
            <div
                className={classNames(
                    Bem.cls({
                        block: 'button-decorator',
                        mods: {
                            valid: valid ? 'yes' : 'no'
                        }
                    }),
                    cls
                )}
            >
                <Button {...passThroughProps} />
            </div>
        );
    }
}
